
import { IUserSession } from '../../../helpers/user-session'

import { LoggerService } from '../../common/common.module'

import { ActorCreateEditController } from './actors-create-edit.directive.controller'

import { ActorHelper } from '../actors.helper'

//#region Asset Imports

import './actors-create-edit.scss'
import * as TEMPLATE from './actors-create-edit.tpl.html'

//#endregion

// Setup

export class ActorCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = ['$scope', '$q', '$timeout', 'logger',  'userSession', (
            $scope: any, 
            $q: ng.IQService, 
            $timeout: ng.ITimeoutService, 
            logger: LoggerService,
            userSession: IUserSession
        ) => new ActorCreateEditController(
            $scope, 
            $q, 
            $timeout, 
            logger, 
            userSession,
            ActorHelper.REFERENCE_TYPE,
            ActorHelper.SIMAX_MODULE_NAME 
        )]
            
    template = TEMPLATE
}

// Setup End